// Port of api/src/auth/uuid.ts — UUIDv7 for entity IDs (spec §5).

export function uuidv7(): string {
  const ts = BigInt(Date.now());
  const rand = new Uint8Array(10);
  crypto.getRandomValues(rand);
  const b = new Uint8Array(16);
  b[0] = Number((ts >> 40n) & 0xffn);
  b[1] = Number((ts >> 32n) & 0xffn);
  b[2] = Number((ts >> 24n) & 0xffn);
  b[3] = Number((ts >> 16n) & 0xffn);
  b[4] = Number((ts >> 8n) & 0xffn);
  b[5] = Number(ts & 0xffn);
  b[6] = (rand[0]! & 0x0f) | 0x70; // version 7
  b[7] = rand[1]!;
  b[8] = (rand[2]! & 0x3f) | 0x80; // variant 10
  b[9] = rand[3]!;
  for (let i = 4; i < 10; i++) b[6 + i] = rand[i]!;
  const hex = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}`;
}
